const API_URL = process.env.NEXT_PUBLIC_API_URL;

export async function apiFetch(endpoint: string, options: RequestInit = {}) {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    let errorMessage = data?.error || 'An unexpected error occurred.';
    
    if (data?.detail) {
      if (Array.isArray(data.detail) && data.detail.length > 0) {
        errorMessage = data.detail.map((err: any) => err.msg || 'Validation error').join(', ');
      } else if (typeof data.detail === 'string') {
        errorMessage = data.detail;
      }
    } else if (!data?.error && typeof data === 'object' && data !== null) {
      const firstKey = Object.keys(data)[0];
      if (Array.isArray(data[firstKey]) && data[firstKey].length > 0) {
        if (typeof data[firstKey][0] === 'string') {
          errorMessage = data[firstKey][0];
        } else {
          errorMessage = JSON.stringify(data[firstKey][0]);
        }
      }
    }
    
    throw new Error(errorMessage);
  }

  return data;
}
